import styled from "styled-components"

export const StickyContainer = styled.div`
    position: sticky;
    top: 0;
    background: #FFF;
    padding: 0.5rem 0;
    z-index: 999;

    button{
        color: #FFF;
        
        border: none;
        background: #7A05A7;
        padding: 0.5rem;
        border-radius: 5px;

        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
    }
`
